import { Common } from "../Components/Canvas";
import Draw from "./draw";
import Utility from "../js/utility";

export default class Spray {
  constructor(history) {
    this.ctx = Common.main_ctx;
    this.history_ctx = Common.history_ctx;
    this.canvas_spray = Common.spray_canvas;
    this.ctx_spray = Common.spray_ctx;
    this.dummyCanvas = document.createElement("canvas");
    this.ctx_dummy = this.dummyCanvas.getContext("2d");
    this.history = history;
    this.points = [];

    this.dummyCanvas.width = Common.canvas_width;
    this.dummyCanvas.height = Common.canvas_height;
    this.canvas_spray.width = Common.canvas_width;
    this.canvas_spray.height = Common.canvas_height;
    this.ctx_dummy.globalAlpha = Common.sprayOpacity;

    let down = Common.mobile ? "ontouchstart" : "onmousedown";
    let up = Common.mobile ? "ontouchend" : "onmouseup";

    this.canvas_spray[down] = (ev) => {
      this.points.push(Utility.getPoints(ev));
    };

    this.canvas_spray[up] = () => {
      this.points.length = 0;
    };
  }

  drawSpray = (ev) => {
    if (!Common.mobile && ev.buttons !== 1) return;

    Utility.hideMenus();

    let blur = 5;

    this.ctx_spray.lineWidth = Common.width;
    this.ctx_spray.lineJoin = this.ctx_spray.lineCap = "round";
    this.ctx_spray.strokeStyle = Common.color;
    this.ctx_dummy.globalAlpha = blur;
    this.points.push(Utility.getPoints(ev));

    this.ctx_spray.clearRect(
      0,
      0,
      this.ctx_spray.canvas.width,
      this.ctx_spray.canvas.height
    );
    this.ctx_spray.beginPath();

    // spray glitter when it's selected;
    if (Common.selectedGlitter) {
      let ctx = Common.main_ctx;
      let patternImage = Draw.glitter_image;
      let pattern = ctx.createPattern(patternImage, "repeat");

      this.ctx_spray.strokeStyle = pattern;
    }

    this.ctx_spray.moveTo(this.points[0].x, this.points[0].y);
    for (var i = 1; i < this.points.length; i++) {
      this.ctx_spray.lineTo(this.points[i].x, this.points[i].y);
    }

    this.ctx_spray.filter = "blur(" + blur + "px)";
    this.ctx_spray.stroke();
    this.ctx_spray.beginPath();
  };

  drawSprayEnd = () => {
    Utility.revealMenus();

    this.ctx_dummy.drawImage(this.canvas_spray, 0, 0);
    this.ctx_spray.clearRect(
      0,
      0,
      this.canvas_spray.width,
      this.canvas_spray.height
    );

    this.ctx.drawImage(this.dummyCanvas, 0, 0);
    this.history_ctx.drawImage(this.dummyCanvas, 0, 0);
    this.ctx_dummy.clearRect(
      0,
      0,
      this.canvas_spray.width,
      this.canvas_spray.height
    );

    this.history.addToHistoryTest();
  };
}
